import type { IPermissionGrantRow } from '../components/ui/PermissionGrantTable';
import type { IProdoqCompanyResponse, IProdoqMenuResponse, IProdoqPermissionMenuPayload } from '../../../../../shared/types/prodoq';

export function getDefaultSelectedMenuId(menus: IProdoqMenuResponse[]): number | null {
  const sortedMenus = [...menus].sort((a, b) => a.order - b.order);

  for (const menu of sortedMenus) {
    if (menu.children.length > 0) {
      const firstChild = [...menu.children].sort((a, b) => a.order - b.order)[0];

      if (firstChild) {
        return firstChild.id;
      }
    } else {
      return menu.id;
    }
  }

  return null;
}

export function findSelectedMenu(
  menus: IProdoqMenuResponse[],
  selectedMenuId: number | null,
): IProdoqMenuResponse | IProdoqMenuResponse['children'][number] | null {
  if (!selectedMenuId) {
    return null;
  }

  for (const menu of menus) {
    if (menu.id === selectedMenuId) {
      return menu;
    }

    const child = menu.children.find((item) => item.id === selectedMenuId);

    if (child) {
      return child;
    }
  }

  return null;
}

export function createPermissionRows(
  roles: IProdoqCompanyResponse['roles'],
  permissions: IProdoqMenuResponse['permissions'],
): IPermissionGrantRow[] {
  return [...roles]
    .sort((a, b) => a.order - b.order)
    .map((role) => {
      const permission = permissions.find((item) => item.roleId === role.id);

      return {
        roleId: role.id,
        roleName: role.roleName,
        read: permission?.read ?? 'N',
        create: permission?.create ?? 'N',
        update: permission?.update ?? 'N',
        delete: permission?.delete ?? 'N',
      };
    });
}

export function createPermissionRequestPayload(menus: IProdoqMenuResponse[]): IProdoqPermissionMenuPayload[] {
  const leafMenus = menus.reduce<Array<IProdoqMenuResponse | IProdoqMenuResponse['children'][number]>>((accumulator, menu) => {
    if (menu.children.length > 0) {
      return [...accumulator, ...menu.children];
    }

    return [...accumulator, menu];
  }, []);

  return leafMenus.map((menu) => ({
    menuId: menu.id,
    permissions: menu.permissions.map((permission) => ({
      roleId: permission.roleId,
      read: permission.read,
      create: permission.create,
      update: permission.update,
      delete: permission.delete,
    })),
  }));
}
